import { useBestIntegrationCodes } from '@/features/modelIntegrationCodes/hooks/useBestIntegrationCodes'
import ModelOption from '@/features/modelIntegrationCodes/pages/Show/components/ModelOption'
import {
  IntegrationCodeMatch,
  integrationCodeMatchKey,
} from '@/features/modelIntegrationCodes/types/suggestedModel.type'

interface SimilarTabProps {
  modelIntegrationCodeId?: string
  equipmentId?: string
  selectedKey?: string
  onSelect: (model: IntegrationCodeMatch) => void
}

const SimilarTab = ({ modelIntegrationCodeId, equipmentId, selectedKey, onSelect }: SimilarTabProps) => {
  const {
    data: models = [],
    isPending,
    isFetching,
  } = useBestIntegrationCodes({
    modelIntegrationCodeId,
    equipmentId,
  })

  if (!equipmentId) {
    return <p className="text-xs italic text-white-400">Selecione um equipamento para listar os modelos semelhantes.</p>
  }

  if (isPending || isFetching) {
    return <p className="text-xs italic text-white-400">Carregando modelos semelhantes...</p>
  }

  if (!models.length) {
    return <p className="text-xs italic text-white-400">Nenhum modelo semelhante encontrado.</p>
  }

  return (
    <div className="flex flex-col gap-2 overflow-y-auto pr-2">
      {models.map((model) => {
        const key = integrationCodeMatchKey(model)
        return <ModelOption key={key} model={model} isSelected={selectedKey === key} onSelect={() => onSelect(model)} />
      })}
    </div>
  )
}

export default SimilarTab
